import { StateCreator } from 'zustand'

import { AvailableSignalsResponse, Signal } from '../types'

interface SignalsState {
  signalAvailability: AvailableSignalsResponse
  signals: Signal[]
}

interface SignalsActions {
  setSignalAvailability: (availability: AvailableSignalsResponse) => void
  setSignals: (signals: Signal[]) => void
}

export type SignalsSlice = SignalsState & SignalsActions

export const initialSignalsState: SignalsState = {
  signalAvailability: { available: [], unavailable: [] },
  signals: [],
}

const createSignalsSlice: StateCreator<SignalsSlice, [], [], SignalsSlice> = (set, get) => ({
  ...initialSignalsState,
  setSignalAvailability: (signalAvailability) => set({ signalAvailability }),
  setSignals: (signals) => {
    if (JSON.stringify(get().signals) !== JSON.stringify(signals)) {
      set({ signals })
    }
  },
})

export default createSignalsSlice
